import React, { useState, useEffect, useRef } from 'react'
import Textarea from '@peracto/peracto-editor-ui/dist/Textarea'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { faArrowsV } from '@fortawesome/pro-regular-svg-icons/faArrowsV'
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import FAQsItemSort from './FAQsItemSort'

const hasContent = str => !!str?.replace(/<[^>]+>/g, '').trim()

const FAQsForm = ({
    onChange,
    state: { faqs = [], selectedFaqIndex },
}) => {
    const [manageItemOrder, setManageItemOrder] = useState(false)
    const [draftFaq, setDraftFaq] = useState(null)
    const onChangeRef = useRef(onChange)
    onChangeRef.current = onChange

    useEffect(() => {
        return () => {
            onChangeRef.current({ selectedFaqIndex: null })
        }
    }, [])

    const handleDraftChange = (field, value) => {
        const updated = { ...draftFaq, [field]: value }
        if (hasContent(updated.question) || hasContent(updated.answer)) {
            onChange({ faqs: [...faqs, updated], selectedFaqIndex: faqs.length })
            setDraftFaq(null)
        } else {
            setDraftFaq(updated)
        }
    }

    return (
        <>
            <button
                className={`btn btn-sm w-100 mb-2 ${
                    manageItemOrder ? 'btn-success' : 'btn-secondary'
                }`}
                onClick={() => setManageItemOrder(!manageItemOrder)}
            >
                <FontAwesomeIcon icon={manageItemOrder ? faCheck : faArrowsV} className="mr-2" />{' '}
                {manageItemOrder ? 'Done' : 'Manage Item Order'}
            </button>

            {manageItemOrder ? (
                <FAQsItemSort faqs={faqs} onChange={onChange} />
            ) : (
                <>
                    {draftFaq !== null ? (
                        <>
                            <Textarea
                                label="Question"
                                onChange={(e, editor) => handleDraftChange('question', editor.getData())}
                                value={draftFaq.question}
                            />
                            <Textarea
                                label="Answer"
                                onChange={(e, editor) => handleDraftChange('answer', editor.getData())}
                                value={draftFaq.answer}
                            />
                        </>
                    ) : (
                        <>
                            {selectedFaqIndex !== null && faqs && faqs[selectedFaqIndex] && (
                                <>
                                    <Textarea
                                        label="Question"
                                        onChange={(e, editor) => {
                                            const faqsClone = [...faqs]
                                            faqsClone[selectedFaqIndex].question = editor.getData()
                                            onChange({ faqs: faqsClone })
                                        }}
                                        value={faqs[selectedFaqIndex].question}
                                    />

                                    <Textarea
                                        label="Answer"
                                        onChange={(e, editor) => {
                                            const faqsClone = [...faqs]
                                            faqsClone[selectedFaqIndex].answer = editor.getData()
                                            onChange({ faqs: faqsClone })
                                        }}
                                        value={faqs[selectedFaqIndex].answer}
                                    />

                                    <button
                                        className="btn btn-sm btn-danger w-100 mt-2"
                                        onClick={() => {
                                            const faqsClone = [...faqs]
                                            faqsClone.splice(selectedFaqIndex, 1)
                                            onChange({ faqs: faqsClone })
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} className="mr-2" /> Remove FAQ Item
                                    </button>
                                </>
                            )}

                            {selectedFaqIndex !== null && faqs?.length > 0 && (
                                <hr className="my-2" style={{ borderTop: '1px solid #666' }} />
                            )}
                        </>
                    )}

                    {draftFaq === null && (
                        <button
                            className="btn btn-sm btn-secondary w-100"
                            disabled={draftFaq !== null}
                            onClick={() => setDraftFaq({ question: '', answer: '' })}
                        >
                            <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add FAQ Item
                        </button>
                    )}
                </>
            )}
        </>
    )
}

export default FAQsForm
